import { Link } from "react-router-dom";
import { HOME } from "@/constants/testIds";
import AnnouncementBar from "@/components/AnnouncementBar";

const LOGO_URL = "/brand-logo.png";
const ICON_URL = "/app-icon.png";

export default function NavBar({ transparent = false }) {
  return (
    <>
    <AnnouncementBar />
    <nav
      className={`${transparent ? "bg-transparent" : "bg-gg-bg/85 backdrop-blur-md border-b border-gg-border"} sticky top-0 z-40`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2.5"
          data-testid={HOME.navLogo}
        >
          <img
            src={ICON_URL}
            alt=""
            aria-hidden="true"
            className="h-10 w-10 rounded-full ring-1 ring-gg-border/60 select-none"
            draggable={false}
          />
          <img
            src={LOGO_URL}
            alt="Graceful Garden Coaching"
            className="h-12 w-auto select-none"
            draggable={false}
          />
        </Link>
        <div className="hidden md:flex items-center gap-8 text-sm">
          <Link
            to="/"
            className="text-[var(--gg-text)] hover:text-gg-green transition-colors"
            data-testid="nav-home-link"
          >
            Home
          </Link>
          <Link
            to="/#classes"
            className="text-[var(--gg-text)] hover:text-gg-green transition-colors"
            data-testid={HOME.navClasses}
          >
            Upcoming Classes
          </Link>
          <Link
            to="/services"
            className="text-[var(--gg-text)] hover:text-gg-green transition-colors"
            data-testid="nav-services-link"
          >
            1-on-1 &amp; Consulting
          </Link>
          <Link
            to="/#about"
            className="text-[var(--gg-text)] hover:text-gg-green transition-colors"
            data-testid={HOME.navAbout}
          >
            About Heather
          </Link>
          <Link
            to="/#faq"
            className="text-[var(--gg-text)] hover:text-gg-green transition-colors"
            data-testid={HOME.navFaq}
          >
            FAQ
          </Link>
          <Link
            to="/blog"
            className="text-[var(--gg-text)] hover:text-gg-green transition-colors"
            data-testid="nav-blog-link"
          >
            Journal
          </Link>
          <Link
            to="/gallery"
            className="text-[var(--gg-text)] hover:text-gg-green transition-colors"
            data-testid="nav-gallery-link"
          >
            Gallery
          </Link>
          <a
            href="mailto:Heather@gracefulgardencoaching.com?subject=Question%20for%20Graceful%20Garden%20Coaching"
            className="text-[var(--gg-text)] hover:text-gg-green transition-colors"
            data-testid="nav-contact-link"
          >
            Contact
          </a>
          <Link
            to="/admin/login"
            className="text-gg-brown hover:text-gg-green transition-colors text-xs uppercase tracking-[0.18em] font-semibold"
            data-testid={HOME.navAdmin}
          >
            Admin
          </Link>
        </div>
      </div>
    </nav>
    </>
  );
}
